export default __webpack_public_path__ + "static/media/phone_icon_moz.2ad8f399.png";